import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import '../styles/MakePicksForm.css';

const formatDate = (date) => {
  const options = { month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric' };
  return new Date(date).toLocaleDateString(undefined, options);
};

const MakePicksForm = ({ collectPicks, userPicks }) => {
  const [games, setGames] = useState([]);

  const API_BASE_URL = process.env.REACT_APP_API_URL || '';

  useEffect(() => {
    const fetchGames = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/games/upcoming`);
        const data = await response.json();
        const currentDate = new Date();

        const gamesWithStatus = data.map((game) => ({
          ...game,
          isLateEntry: new Date(game.date) <= currentDate,
        }));

        setGames(gamesWithStatus);
      } catch (error) {
        console.error('Error fetching current season upcoming games:', error);
      }
    };

    fetchGames();
  }, [API_BASE_URL]);

  // ------------------------------------------------------
  // ✅ CLEAN BRACKET UPDATE BASED ONLY ON nextGameId & nextGameTeam
  // ------------------------------------------------------
    const updateBracket = (gameId, selectedTeamName) => {
      const selectedGame = games.find((game) => game._id === gameId);
      if (!selectedGame) return;

      // 1️⃣ Update the clicked game with the user's pick
      setGames((prevGames) =>
        prevGames.map((game) =>
          game._id === gameId
            ? { ...game, userPick: selectedTeamName }
            : game
        )
      );

      // 2️⃣ Update ONLY the immediate nextGame
      const { nextGameId, nextGameTeam } = selectedGame;

      if (!nextGameId || !nextGameTeam) return; // no downstream game

      setGames((prevGames) =>
        prevGames.map((game) =>
          game._id === nextGameId
            ? {
                ...game,
                [nextGameTeam]: selectedTeamName, // fill the correct slot
                userPick: null,                  // clear the user's pick for that game
              }
            : game
        )
      );
    };

  // ------------------------------------------------------

  const handlePick = (gameId, selectedTeamName) => {
    const selectedGame = games.find((g) => g._id === gameId);
    if (!selectedGame) return;

    const pickDetails = {
      gameName: selectedGame.name,
      spread: selectedGame.spread,
      selectedTeam: selectedTeamName,
      matchup: `${selectedGame.team1} vs ${selectedGame.team2}`,
      favorite: selectedGame.favorite,
      fabbrev: selectedGame.fabbrev,
    };

    updateBracket(gameId, selectedTeamName);

    collectPicks((prev) => ({
      ...prev,
      [gameId]: pickDetails,
    }));
  };

  return (
    <div className="make-picks-container">
      <h2>Step 1: Make Your Picks</h2>
      <div>
        Pick the winner for each bowl game. Spread is provided for context only.
      </div>
      <div>
        {games && games.length > 0 ? (
          games.map((game) => (
            <div
              key={game._id}
              className={`game-card ${game.isLateEntry ? 'late-entry' : ''}`}
              style={{ opacity: game.isLateEntry ? 0.5 : 1 }}
            >
              <h3>{game.name}</h3>
              <div className='spreada'>
                Spread:{' '}
                {game.fabbrev && game.spread
                  ? `${game.fabbrev} ${game.spread}`
                  : 'TBD'}
              </div>
              <div className='kickoff'>Kickoff: {formatDate(game.date)}</div>
              <div className="teams-container">
                <div
                  className={`team-card ${
                    userPicks[game._id]?.selectedTeam === game.team1
                      ? 'selected'
                      : ''
                  }`}
                  onClick={() =>
                    !game.isLateEntry && handlePick(game._id, game.team1)
                  }
                >
                  {game.team1}
                </div>
                <div
                  className={`team-card ${
                    userPicks[game._id]?.selectedTeam === game.team2
                      ? 'selected'
                      : ''
                  }`}
                  onClick={() =>
                    !game.isLateEntry && handlePick(game._id, game.team2)
                  }
                >
                  {game.team2}
                </div>
              </div>
            </div>
          ))
        ) : (
          <p>2025 bowl games will be added on December 8th.</p>
        )}
      </div>
    </div>
  );
};

MakePicksForm.propTypes = {
  userPicks: PropTypes.object.isRequired,
  collectPicks: PropTypes.func.isRequired,
};

export default MakePicksForm;
